<template>
    <div>
        <div class="modal hide fade" id="modalPurchasingListSchedule" tabindex="-1" role="dialog" aria-labelledby="modalPurchasingListSchedule" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">
                            Schedule Payment
                        </h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-group row">
                            <label for="payment_date" class="col-sm-3 col-form-label text-left">Date</label>
                            <div class="col-sm-9">
                                <datetime v-model="schedule_payment_date" format="dd/MM/yyyy" class="form-control" value-zone="local" zone="local"></datetime>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-hard-primary" @click="process">Process</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'PurchasingListModal',
  data () {
    return {
      schedule_payment_date: new Date().toISOString()
    }
  },
  methods: {
    process () {
      this.$emit('getDate', this.schedule_payment_date)
    }
  }
}
</script>
